import { useEffect } from "react";

export function useAutofocus(ref: React.RefObject<HTMLElement | null>) {
    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, [ref]);
}
